/* FooterDisclaimer.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./FooterDisclaimer.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useIntl } from 'react-intl-next';
import InfoIcon from '@atlaskit/icon/utility/migration/information--info';
import { fg } from '@atlaskit/platform-feature-flags';
import { Anchor, Inline } from '@atlaskit/primitives/compiled';
import messages from '../messages';
import { CustomDisclaimer } from './CustomDisclaimer';
var linkStyles = {
  default: "_11c81o8v _4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz1gjq _10531gjq _9oik1r31 _1bnx8stv _jf4cnqa1 _30l31gjq",
  updated: "_11c81o8v _syaz1gjq _10531gjq"
};
export function FooterDisclaimer(_ref) {
  var disclaimer = _ref.disclaimer,
    appearance = _ref.appearance;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return disclaimer ? /*#__PURE__*/React.createElement(CustomDisclaimer, {
    disclaimer: disclaimer
  }) : /*#__PURE__*/React.createElement(Inline, {
    space: "space.050",
    alignBlock: "center"
  }, /*#__PURE__*/React.createElement(InfoIcon, {
    label: formatMessage(messages.infoIconLabel),
    color: "var(--ds-text-subtle, #44546F)",
    LEGACY_size: "small"
  }), /*#__PURE__*/React.createElement(Anchor, {
    color: "var(--ds-text-subtle, #44546F)",
    href: "https://www.atlassian.com/trust/atlassian-intelligence"
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    ,
    xcss: fg('editor_a11y_ai_footer_link_variation') ? linkStyles.updated : linkStyles.default
  }, formatMessage(
  // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
  fg('editor_a11y_ai_footer_link_variation') ? messages.disclaimerTextUpdated : appearance === 'large' ? messages.disclaimerText : messages.disclaimerTextShort)));
}